import cookies from 'js-cookie';

const deleteCookie = (name: string) => {
    if (name && cookies.get(name)) cookies.remove(name);
};

/**
 * @param cookiesNames имя куки или массив имен
 */
export const removeCookies = (cookiesNames?: string | string[]) => {
    if (Array.isArray(cookiesNames)) {
        cookiesNames.forEach(name => deleteCookie(name));
    } else if (typeof cookiesNames === 'string') {
        deleteCookie(cookiesNames);
    }
};
